var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 20,
    viewBox: "0 0 51 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12220_629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.35403 7.32312L7.26172 7.32312L7.26172 5.53851L5.35403 5.53851L5.35403 7.32312Z",
    fill: "#49474B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26128 5.53845L9.0459 5.53845L9.0459 3.63076L7.26128 3.63076L7.26128 5.53845Z",
    fill: "#49474B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04592 3.63074L10.9536 3.63074L10.9536 1.84612L9.04592 1.84612L9.04592 3.63074Z",
    fill: "#49474B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11L11 11L11 9L9 9L9 11Z",
    fill: "#49474B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84624 11.0154L3.63086 11.0154L3.63086 9.23077L1.84624 9.23077L1.84624 11.0154Z",
    fill: "#7D7B7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63093 9.23071L5.354 9.23071L5.354 7.32302L3.63093 7.32302L3.63093 9.23071Z",
    fill: "#7D7B7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63093 12.7384L5.354 12.7384L5.354 11.0153L3.63093 11.0153L3.63093 12.7384Z",
    fill: "#7D7B7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1753 11L16 11L16 9L14.1753 9L12.5803 9L11 9L11 11L12.5803 11L14.1753 11Z",
    fill: "#7D7B7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26128 16.4308L9.0459 16.4308L9.0459 14.6462L7.26128 14.6462L7.26128 16.4308Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04592 18.277L10.9536 18.277L10.9536 16.4308L9.04592 16.4308L9.04592 18.277Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 11L24 11L24 9L22 9L22 11Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.36 11L31.1483 11L33 11L33 9L31.1483 9L29.36 9L27.5717 9L26 9L26 11L27.5717 11L29.36 11Z",
    fill: "#ACABAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35403 14.6461L7.26172 14.6461L7.26172 12.7384L5.35403 12.7384L5.35403 14.6461Z",
    fill: "#ACABAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8562 11L22 11L22 9L19.8562 9L17.8411 9L16 9L16 11L17.8411 11L19.8562 11Z",
    fill: "#ACABAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 11L26 11L26 9L24 9L24 11Z",
    fill: "#ACABAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 11L34.6439 11L36.4424 11L38.2403 11L40.0382 11L41.8361 11L43.5438 11L45.3423 11L47.1395 11L49 11L49 9L47.1395 9L45.3423 9L43.5438 9L41.8361 9L40.0382 9L38.2403 9L36.4424 9L34.6439 9L33 9L33 11Z",
    fill: "#7D7B7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84624 9.23071L3.63086 9.23071L3.63086 7.32302L1.84624 7.32302L1.84624 9.23071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63093 7.32312L5.354 7.32312L5.354 5.53851L3.63093 5.53851L3.63093 7.32312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63093 11.0154L5.354 11.0154L5.354 9.23077L3.63093 9.23077L3.63093 11.0154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35403 5.53845L7.26172 5.53845L7.26172 3.63076L5.35403 3.63076L5.35403 5.53845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35403 9.23071L7.26172 9.23071L7.26172 7.32302L5.35403 7.32302L5.35403 9.23071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35403 12.7384L7.26172 12.7384L7.26172 11.0153L5.35403 11.0153L5.35403 12.7384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26128 3.63074L9.0459 3.63074L9.0459 1.84612L7.26128 1.84612L7.26128 3.63074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26128 7.32312L9.0459 7.32312L9.0459 5.53851L7.26128 5.53851L7.26128 7.32312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26128 14.6461L9.0459 14.6461L9.0459 12.7384L7.26128 12.7384L7.26128 14.6461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04597 1.84612L10.9537 1.84612L10.9537 3.63074L12.7383 3.63074L12.7383 1.84981L12.7383 -3.13042e-05L10.8454 -3.14697e-05L9.04597 -3.1627e-05L9.04597 1.84612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04592 5.53845L10.9536 5.53845L10.9536 3.63076L9.04592 3.63076L9.04592 5.53845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4602 9L11.9528 9L13.3705 9L14.9381 9L16.3563 9L17.8489 9L19.3416 9L20.8342 9L22.3268 9L23.7451 9L25.2377 9L26.7303 9L28.223 9L29.6407 9L31.1338 9L32.6265 9L34.1191 9L35.6117 9L37.0295 9L38.5226 9L40.0147 9L41.5079 9L42.9256 9L44.4931 9L45.9109 9L47.4035 9L49 9L49 7L47.4035 7L45.9109 7L44.4931 7L42.9256 7L41.5079 7L40.0147 7L38.5226 7L37.0295 7L35.6117 7L34.1191 7L32.6265 7L31.1338 7L29.6407 7L28.223 7L26.7303 7L25.2377 7L23.7451 7L22.3268 7L20.8342 7L19.3416 7L17.8489 7L16.3563 7L14.9381 7L13.3705 7L11.9528 7L10.4602 7L9 7L9 9L10.4602 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04592 16.4308L10.9536 16.4308L10.9536 14.6462L9.04592 14.6462L9.04592 16.4308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75509e-05 11.0154L1.84619 11.0154L1.84619 9.23077L3.77069e-05 9.23077L3.75509e-05 11.0154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84624 12.7384L3.63086 12.7384L3.63086 11.0153L1.84624 11.0153L1.84624 12.7384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63093 14.6461L5.354 14.6461L5.354 12.7384L3.63093 12.7384L3.63093 14.6461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35403 16.4308L7.26172 16.4308L7.26172 14.6462L5.35403 14.6462L5.35403 16.4308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26128 11.0154L9.0459 11.0154L9.0459 9.23077L7.26128 9.23077L7.26128 11.0154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26128 18.277L9.0459 18.277L9.0459 16.4308L7.26128 16.4308L7.26128 18.277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13L10.4602 13L11.9528 13L13.3705 13L14.9381 13L16.3563 13L17.8489 13L19.3416 13L20.8342 13L22.3268 13L23.7451 13L25.2377 13L26.7303 13L28.223 13L29.6407 13L31.1338 13L32.6265 13L34.1191 13L35.6117 13L37.0295 13L38.5226 13L40.0147 13L41.5079 13L42.9256 13L44.4931 13L45.9109 13L47.4035 13L49 13L49 11L47.4035 11L45.9109 11L44.4931 11L42.9256 11L41.5079 11L40.0147 11L38.5226 11L37.0295 11L35.6117 11L34.1191 11L32.6265 11L31.1338 11L29.6407 11L28.223 11L26.7303 11L25.2377 11L23.7451 11L22.3268 11L20.8342 11L19.3416 11L17.8489 11L16.3563 11L14.9381 11L13.3705 11L11.9528 11L10.4602 11L9 11L9 13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8454 20L12.7383 20L12.7383 18.3126L12.7383 16.4308L10.9537 16.4308L10.9537 18.2769L9.04597 18.2769L9.04597 20L10.8454 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 11L51 11L51 9L49 9L49 11Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12220_629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 20,
    fill: "white",
    transform: "translate(51 20) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.8d37aeaf09591c9330aaad8197efa3e6.svg";
export { ForwardRef as ReactComponent };